import './common/numericInput'
import './common/collections'
import './common/dateragePicker'
import './common/formPredata'

$.extend($.fn.bootstrapTable.defaults, $.fn.bootstrapTable.locales[snakeCaseLocale])

/**
 * Prototyp funkcji do zmiany wszystkich wystąpień w stringu
 *
 * https://stackoverflow.com/questions/1144783/how-can-i-replace-all-occurrences-of-a-string
 *
 * @param search
 * @param replacement
 * @returns {string}
 */
String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};


/**
 * Funckja dla elementów, które rozjezdzają się na  więcej niż jedną  linię w tabeli.
 * Np. buttony, nie chcemy, żeby były jedne pod drugimi, ale też nie chcemy, żeby  kolumna tej tabeli
 * była za duża
 *
 * W atrybutach kolumny ustawiamy data-width=1
 *
 * Następnie cały html w kolumnie zamykamy w div'a z klasą auto-width
 *
 * Funkcja znajduje buttony i anchory  jako bezpośredni dzieci .auto-width sumuje
 * ich szerokość dodaje 20 i ustawia szerokość elementu  .auto-width
 */
$('body').on('load-success.bs.table', function () {
    activeAutoWidth()
})

window.activeAutoWidth = function () {
    $('.auto-width').each(function () {
        var totalWidth = 0;
        $(this).children('a, button').each(function () {
            totalWidth += $(this).outerWidth()
        })
        $(this).width(totalWidth + 20)
    });
}

/**
 * Funkcja która przy zmianie filtrów w tabeli automatycznie ją odświeża
 */
$('body').on('change', '.pda-table-form input, .pda-table-form select', function () {
    $('.pda-table-form').submit()
})

/**
 * Aktywacja select2
 */
$(function () {
    $('.select2:not([multiple])').select2({
        width: '100%',
    })

    $('.select2[multiple]').select2({
        width: '100%',
        closeOnSelect: false
    })
})

/**
 * Funkcja która aktywuje element w menu. używamy jej wysyłając href który ma być aktywowany
 */
window.activeMenuItem = function (href) {
    $('.metismenu  a').removeClass('active')
    if ($('.metismenu  a[href="' + href + '"]').length) {
        $('.metismenu  a[href="' + href + '"]')
            .addClass('active')
            .parent('li')
            .parent('ul')
            .addClass('in')
            .attr('aria-expanded', 'true')
            .parent('li')
            .addClass('active')
    } else {
        $(href)
            .addClass('active')
            .parent('li')
            .parent('ul')
            .addClass('in')
            .attr('aria-expanded', 'true')
            .parent('li')
            .addClass('active')
    }
}


/**
 * Funkcj do aktywowania numeric inputów
 */
$(function () {
    numericInputActive()
})

/**
 * Numeric inputy korzystające z  bibloteki numerycznej
 */
global.numericInputActive = function numericInputActive() {
    $('.float-input').numericInput({
        allowFloat: true,
        allowNegative: false
    })
    $('.integer-input').numericInput({
        allowFloat: false,
        allowNegative: false
    })
    $('.percent-input').on('keyup', function () {
        var val = $(this).val()
        if (val == '') {
            return
        }

        val = parseInt(val)
        if (isNaN(val)) {
            val = 0
        }
        $(this).val(val)

        if (val > 100) {
            $(this).val(100)
        }

        if (val < 0) {
            $(this).val(0)
        }
    }).on('change', function () {
        var val = $(this).val()
        if (val == '') {
            return $(this).val(0)
        }
    })
}

/**
 * Bardzo prosta a super funkcjonalna funkcja :P
 *
 * No więc jeżeli do tabeli Bootstrapowej dodamy:
 *
 * 'data-detail-view' => 'true',
 * 'data-detail-formatter' => 'detailFormatter'
 *
 * W resources możemy wysłać dowolny HTML pod kluczem details, który zostanie wyświetlon w dodatkwych
 *
 * @param index
 * @param row
 * @returns {any}
 */
global.detailFormatter = function detailFormatter(index, row) {
    return row.details;
}
